
import { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  TextField,
  Grid,
  Paper,
  Button,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel as MuiFormControlLabel,
  Radio,
  IconButton
} from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { selectActiveContract } from '../../../../reducers/contracts/contractsSelectors';
import { startContractsUpdate } from '../../../../reducers/contracts/contractsActions';
import { CustomDateTimePicker } from '../../../common/CustomDateTimePicker/CustomDateTimePicker';
import { GoBack } from '../../../common/GoBack/GoBack';
import { useNavigate } from 'react-router-dom';

const fields = [
  "name", "start_date", "end_date", "contractor", "responsible", "contact", "comments",
  "equipment_devices", "cm_devices", "nodes_devices", "telemeasures_devices",
  "contract_price", "node_price", "cm_price", "telemeasures_price", "contract_state", "status_flag"
];

export const ContractAdminManagementForm = () => {
  const dispatch = useDispatch();
  const activeContract = useSelector(selectActiveContract);
  const navigate = useNavigate();


  const [formData, setFormData] = useState(() =>
    fields.reduce((acc, field) => ({ ...acc, [field]: '' }), {})
  );

  useEffect(() => {
    if (activeContract) {
      const filteredData = {};
      fields.forEach(field => {
        filteredData[field] = activeContract[field] ?? '';
      });
      setFormData(filteredData);
    }
  }, [activeContract]);

  const handleChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!activeContract) return;

    const updatedFormData = {
      ...formData,
      status_flag: 0
    };
    dispatch(startContractsUpdate(updatedFormData));
    handleGoBack();
  };

  const handleGoBack = () => {
    //vuelve a renovaciones sas
    navigate('/dashboard', { state: { view: 'adminContracts' } });
  };

  const fieldLabels = {
    name: "Contrato",
    start_date: "Fecha de inicio",
    end_date: "Fecha de vencimiento",
    contractor: "Contratista",
    responsible: "Persona responsable",
    contact: "Email y teléfono",
    comments: "Comentarios",
    equipment_devices: "Detalles de equipos",
    cm_devices: "Nº CM",
    nodes_devices: "Nº NODOS",
    telemeasures_devices: "Nº TELEMEDIDAS",
    contract_price: "Coste anual",
    node_price: "Precio por nodo",
    cm_price: "Precio por CM",
    telemeasures_price: "Precio por telemedida",
    contract_state: "Estado del contrato"
  };

  return (
    <Box sx={{ p: 4 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }} >


        <GoBack to="/dashboard" state={{ view: 'adminContracts' }} />
        {/** 
         *  <IconButton
          edge="end"
          aria-label="go-back"
          onClick={handleGoBack}
          sx={{ width: 56, height: 56, marginRight: 1 }}
        >
          <ArrowBackIosIcon />
        </IconButton>
         *  **/}
        <Typography variant="h5" >
          Gestión del contrato
        </Typography>
      </Box>
      <Paper sx={{ p: 3 }}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label={fieldLabels.name}
                fullWidth
                disabled
                value={formData.name}
                onChange={(e) => handleChange("name", e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <CustomDateTimePicker
                label={fieldLabels.start_date}
                value={formData.start_date}
                onChange={(value) => handleChange("start_date", value)}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <CustomDateTimePicker
                label={fieldLabels.end_date}
                value={formData.end_date}
                onChange={(value) => handleChange("end_date", value)}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                label={fieldLabels.contractor}
                fullWidth
                value={formData.contractor}
                onChange={(e) => handleChange("contractor", e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label={fieldLabels.responsible}
                fullWidth
                value={formData.responsible}
                onChange={(e) => handleChange("responsible", e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label={fieldLabels.contact}
                fullWidth
                value={formData.contact}
                onChange={(e) => handleChange("contact", e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label={fieldLabels.comments}
                fullWidth
                multiline
                minRows={4}
                value={formData.comments}
                onChange={(e) => handleChange("comments", e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label={fieldLabels.equipment_devices}
                fullWidth
                multiline
                minRows={4}
                value={formData.equipment_devices}
                onChange={(e) => handleChange("equipment_devices", e.target.value)}
              />
            </Grid>

            {[
              "cm_devices", "nodes_devices", "telemeasures_devices",
              "node_price", "cm_price", "telemeasures_price"
            ].map(field => (
              <Grid item xs={12} sm={2} key={field}>
                <TextField
                  label={fieldLabels[field]}
                  fullWidth
                  value={formData[field]}
                  onChange={(e) => handleChange(field, e.target.value)}
                />
              </Grid>
            ))}
            <Grid item xs={12} sm={2}>
              <TextField
                label={fieldLabels.contract_price}
                fullWidth
                value={formData.contract_price}
                onChange={(e) => handleChange("contract_price", e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <FormControl component="fieldset">
                <FormLabel component="legend">{fieldLabels.contract_state}</FormLabel>
                <RadioGroup
                  row
                  value={formData.contract_state?.toString() || '0'}
                  onChange={(e) => handleChange("contract_state", parseInt(e.target.value))}
                >
                  <MuiFormControlLabel value="0" control={<Radio />} label="En curso" />
                  <MuiFormControlLabel value="1" control={<Radio />} label="Baja" />
                  <MuiFormControlLabel value="2" control={<Radio />} label="Vencido" />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>

          <Box sx={{ mt: 3, textAlign: 'right' }}>
            <Button type="submit" variant="contained" color="primary">
              Guardar
            </Button>
          </Box>
        </form>
      </Paper>
    </Box>
  );
};


